import "normalize.css";
import React from "react";
import "react-image-gallery/styles/css/image-gallery.css";
import { BrowserRouter as Router, Route, Routes } from "react-router";
import "./App.css";
import { AppProvider } from "./context/AppContext";
import BranchSMS from "./screens/BranchSMS";
import Home from "./screens/Home";
import { Exhibit } from "./screens/Exhibit";
import Theme from "./helpers/theme";
import { NotFound } from "./pages/NotFound";

const App = () => (
  <AppProvider>
    <Router>
      <Theme>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/topic/:exhibitId?" element={<Exhibit />} />
          <Route path="/download/" element={<BranchSMS />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Theme>
    </Router>
  </AppProvider>
);

export default App;
